import { setupFloatingButtons } from './module/FloatButtonFunctions';

// 設定オブジェクト
const config = {
  floatButtonsSelector: '.fixedBtn-fade',
};

// DOMの読み込みが完了したら設定する
document.addEventListener('DOMContentLoaded', () => {
  // フローティングボタンの設定
  const floatingButtonsConfig = {
    floatButtonsSelector: config.floatButtonsSelector,
  };
  setupFloatingButtons(floatingButtonsConfig);
});
